export default __webpack_public_path__ + "static/media/icon-plan.832bfef6.svg";